import { Injectable } from '@angular/core';
import { ICartCheckoutStatus } from '@core/interfaces/cart/cart-checkout-status.interface';
import { ICartSource } from '@core/interfaces/cart/cart-source.interface';
import { ICart } from '@core/interfaces/cart/cart.interface';
import { IDiscount } from '@core/interfaces/cart/discount.interface';
import { CART_ITEM, CHECKOUT_STATUS_SUCCEEDED_QUEUE, DISCOUNT_MOCK, GET_CART_RESPONSE } from '@core/mocks/cart/cart.mock';
import { SelectEventRequest } from '@core/models/cart/select-event-request.model';
import { AAGUID } from '@interticket/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { DiscountType } from '../../enums/cart/discount-type.enum';

@Injectable()
export class CartSourceMockService implements ICartSource {

  private readonly checkoutStatusQueue: ICartCheckoutStatus[] = CHECKOUT_STATUS_SUCCEEDED_QUEUE;

  isGiftCard: boolean;

  getCart(): Observable<ICart> {
    return of(GET_CART_RESPONSE).pipe(delay(150));
  }

  addToCart(selectEventRequest: SelectEventRequest): Observable<Response> {
    return of(new Response()).pipe(delay(150));
  }

  getCartById(cartId: AAGUID): Observable<ICart> {
    return of(GET_CART_RESPONSE).pipe(delay(150));
  }

  deleteCart(cartId: AAGUID): Observable<Response> {
    return of(new Response()).pipe(delay(150));
  }

  deleteGiftCardsToBuyFromCart(giftCardIds: AAGUID[]): Observable<Response> {
    return of(new Response()).pipe(delay(150));
  }

  deleteFromCart(selectionIds: AAGUID[]): Observable<Response> {
    return of(new Response()).pipe(delay(150));
  }

  deleteGiftCard(couponId: AAGUID): Observable<Response> {
    return of(new Response()).pipe(delay(150));
  }

  checkoutCart(paymentMethodId: AAGUID): Observable<Response> {
    return of(new Response()).pipe(delay(150));
  }

  getCheckoutStatus(): Observable<ICartCheckoutStatus> {
    const checkoutStatus = this.checkoutStatusQueue.shift();
    this.checkoutStatusQueue.push(checkoutStatus);
    // eslint-disable-next-line no-console
    console.log('CheckoutStatus', checkoutStatus);
    return of(checkoutStatus).pipe(delay(150));
  }

  getDiscount(couponId: string): Observable<IDiscount | null> {
    this.isGiftCard = !this.isGiftCard;
    const isGiftCard = this.isGiftCard;
    return of({ ...DISCOUNT_MOCK, discountType: isGiftCard ? DiscountType.GIFTCARD : DiscountType.COUPON }).pipe(delay(150));
  }

  applyDiscounts(cartItemIds: AAGUID[], couponId: AAGUID): Observable<Response> {
    CART_ITEM.discountId = 'ASDASDASADAS';
    CART_ITEM.discountName = 'ASDASDASADAS';
    CART_ITEM.originalPrice = 999999;
    return of(new Response()).pipe(delay(150));
  }

  removeDiscount(cartItemId: AAGUID): Observable<Response> {
    CART_ITEM.discountId = null;
    CART_ITEM.discountName = null;
    CART_ITEM.originalPrice = null;
    return of(new Response()).pipe(delay(150));
  }

}
